import Background from "Components/Atoms/Background/background";
import Button from "Components/Atoms/Button/button";
import H2 from "Components/Atoms/H2/h2";
import Space from "Components/Atoms/Space/space";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { modalToggle } from "Store/Slices/modal";
import { ReactComponent as ModalX } from "Util/svg/modalX.svg";
import InputRow from "../InputRow/inputRow";
import LANG, { getLang } from "Util/lang";
import { useQueryClient } from "@tanstack/react-query";
import { postShortCuts } from "Apis/apis";
import { levelCheck } from "Store/Slices/user";

const ShortcutsPostModal = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    const body = {
      title,
      url,
    };

    await postShortCuts(body);
    queryClient.invalidateQueries(["GetShortCutListApi"]);
    alert("등록이 완료 되었습니다.");
    setTitle("");
    setUrl("");
    dispatch(modalToggle(-2));
  };

  return (
    <Background modalNum={-3}>
      <div style={{ width: "640px" }} className="p-32 bg-f2f3f8">
        <div className="flex justify-between items-center">
          <H2 isPrimary={true} name="바로가기 등록" />

          <div
            className="inline-block cursor-pointer"
            onClick={() => dispatch(modalToggle(-2))}
          >
            <ModalX />
          </div>
        </div>
        <Space y={16} />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            dispatch(
              levelCheck({
                sl: "q06",
                fuc: onSubmit,
              }),
            );
          }}
        >
          <InputRow
            id="title"
            name={LANG[getLang()].title}
            value={title}
            setValue={setTitle}
          />
          <InputRow
            id="link"
            name={LANG[getLang()].link}
            value={url}
            setValue={setUrl}
            placeholder="https 부터 입력"
          />
          <div className="flex justify-end mt-10">
            <Button
              btnText={LANG[getLang()].register}
              type="submit"
              standardItem="q06"
            />
            <Space x={10} />
          </div>
        </form>
      </div>
    </Background>
  );
};

export default ShortcutsPostModal;
